import { ViewManager as Base } from "@baseline/ui/views";
import { views } from "./views";


export class ViewManager extends Base<typeof views>
{
    constructor()
    {
        super(views);
    }
}
